(() => {
  if (window.taffstyleFiltersLoaded) return;
  window.taffstyleFiltersLoaded = true;
  const mobile = window.matchMedia('(max-width: 1000px)');
  let form, dialog, home, opener, saved, controller, timer, generation = 0;
  const q = (s, root = document) => root.querySelector(s);
  const all = (s, root = document) => [...root.querySelectorAll(s)];
  const status = text => { q('[data-tf-status]', form).textContent = text; };
  let diameterGroups = [], countsController, countsRun = 0;
  const countCache = new Map();
  function diameter(value) {
    const text = value.trim().replace(/\u00a0/g, ' ');
    const combined = text.match(/^\s*(\d+(?:[.,]\d+)?)\s*(?:mm)?\s*[x×✕*]\s*(\d+(?:[.,]\d+)?)\s*(?:mm)?\s*$/i);
    const single = text.match(/^\s*(\d+(?:[.,]\d+)?)\s*(?:mm)?\s*$/i);
    const number = combined ? combined[2] : single?.[1];
    return number ? Number(number.replace(',', '.')) : null;
  }
  function diameterLabel(value) {
    return new Intl.NumberFormat(document.documentElement.lang || 'de', {maximumFractionDigits: 3}).format(value) + ' mm';
  }
  function groupDiameters() {
    diameterGroups = [];
    all('[data-tf-kind="diameter"]', form).forEach(facet => {
      const list = q('.tf-options', facet), groups = new Map();
      if (!list) return;
      all('.tf-option', list).forEach(label => {
        const input = q('input[name]', label), number = diameter(label.dataset.value);
        if (!input || number === null) return;
        const key = input.name + ':' + number;
        if (!groups.has(key)) groups.set(key, {name: input.name, number, controls: [], originals: []});
        const group = groups.get(key);
        group.controls.push(input); group.originals.push(label);
      });
      groups.forEach(group => {
        const label = group.originals[0].cloneNode(true), input = q('input', label);
        label.dataset.value = diameterLabel(group.number);
        label.dataset.tfDiameterGroup = String(group.number);
        q('.tf-value', label).textContent = label.dataset.value;
        input.removeAttribute('name'); input.removeAttribute('id'); input.dataset.tfDiameter = String(group.number);
        input.checked = group.controls.some(control => control.checked);
        group.originals.forEach(original => { original.hidden = true; original.classList.add('tf-raw-option'); q('input', original).dataset.tfRaw = ''; });
        group.input = input; group.label = label;
        input.addEventListener('change', () => {
          group.controls.forEach(control => { control.checked = input.checked; if (input.checked) control.disabled = false; });
        });
        list.append(label); diameterGroups.push(group);
      });
    });
  }
  let colorModels = [], colorGroups = [];
  const colorKey = text => text.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss').replace(/\s+/g, '');
  const colorParts = value => value.split(/[-–—/|]/).map(text => text.trim()).filter(Boolean);
  const colorAliases = {weiss:'Weiß',rosegold:'Roségold'};
  function colorName(value) { return colorParts(value).map(part => colorAliases[colorKey(part)] || part).join(' / '); }
  function colorIdentity(value) { return colorParts(value).map(colorKey).join('/'); }
  function paintColor(dot, value, palette) {
    const parts = colorParts(value).map(colorKey), colors = parts.map(part => palette.get(part));
    if (!colors.length || colors.some(color => !color)) return;
    dot.removeAttribute('class'); dot.className = 'tf-dot';
    const background = colors.length === 1 ? colors[0] : 'conic-gradient(' + colors.map((color, i) => color + ' ' + (i * 100 / colors.length) + '% ' + ((i + 1) * 100 / colors.length) + '%').join(',') + ')';
    dot.style.background = background;
  }
  function colorSelections(model) {
    return model.exact.filter(group => group.controls.some(input => input.checked));
  }
  function syncColors() {
    colorGroups.forEach(group => {
      const any = group.controls.some(input => input.checked);
      group.input.checked = any;
      group.input.indeterminate = false;
      if (any) { group.input.disabled = false; group.label.classList.remove('tf-disabled'); }
    });
  }
  function groupColors() {
    colorModels = []; colorGroups = [];
    const copyNode = q('[data-tf-color-copy]', form);
    if (!copyNode) return;
    const copy = JSON.parse(copyNode.textContent), palette = new Map();
    (copy.map || '').split(/\r?\n/).forEach(line => {
      const colon = line.indexOf(':'), key = colorKey(line.slice(0, colon)), value = line.slice(colon + 1).trim();
      if (colon > 0 && /^#[\da-f]{3}(?:[\da-f]{3})?$/i.test(value)) palette.set(key, value);
    });
    all('[data-tf-kind="color"]', form).forEach(facet => {
      const list = q('.tf-options', facet), raw = all('.tf-option', list), exactMap = new Map();
      if (!raw.length) return;
      const model = {facet, exact:[], name:q('input[name]',raw[0]).name};
      const make = (map, key, label, original, kind) => {
        if (!map.has(key)) map.set(key, {name:model.name, key, text:label, controls:[], originals:[], kind, model});
        const group = map.get(key);group.controls.push(q('input[name]',original));group.originals.push(original);
      };
      raw.forEach(label => {
        const value = label.dataset.value;
        make(exactMap,colorIdentity(value),colorName(value),label,'exact');
        label.hidden = true;label.classList.add('tf-raw-option');q('input',label).dataset.tfRaw='';
      });
      const create = (group, destination) => {
        const label=group.originals[0].cloneNode(true), input=q('input',label);
        label.hidden=false;label.classList.remove('tf-raw-option');label.dataset.value=group.text;
        label.dataset.tfColorKind=group.kind;label.dataset.tfColorKey=group.key;
        input.removeAttribute('name');input.removeAttribute('id');delete input.dataset.tfRaw;input.dataset.tfColor='';
        q('.tf-value',label).textContent=group.text;
        let dot=q('.tf-dot',label);
        if (colorParts(group.text).length>1 || dot?.tagName!=='IMG') {
          const replacement=document.createElement('i');replacement.className='tf-dot';replacement.setAttribute('aria-hidden','true');
          if (dot) {replacement.className=dot.className;replacement.style.cssText=dot.style.cssText;dot.replaceWith(replacement);}else q('.tf-option-face',label).prepend(replacement);
          dot=replacement;
          paintColor(dot,group.text,palette);
        }
        group.input=input;group.label=label;
        input.addEventListener('change',()=>{
          group.controls.forEach(control=>{control.checked=input.checked;if(input.checked)control.disabled=false;});
          syncColors();
        });
        destination.append(label);colorGroups.push(group);
      };
      [...exactMap.values()].sort((a,b)=>a.text.localeCompare(b.text,document.documentElement.lang || 'de')).forEach(group=>{create(group,list);model.exact.push(group);});
      facet.addEventListener('toggle',()=>{if(facet.open && (!mobile.matches || dialog?.open))refreshGroupCounts();});
      colorModels.push(model);
    });
    syncColors();
  }
  function groupColorChips() {
    const current=q('[data-tf-current]');if(!current)return;
    colorModels.forEach(model=>{
      const old=all('[data-tf-remove][data-param]',current).filter(chip=>chip.dataset.param===model.name);
      if(!old.length)return;
      const choices=colorSelections(model), fragment=document.createDocumentFragment();
      choices.forEach(group=>{
        const chip=old[0].cloneNode(false), cross=document.createElement('span');cross.setAttribute('aria-hidden','true');cross.textContent='×';
        chip.removeAttribute('aria-label');chip.dataset.value=group.text;
        chip.append(document.createTextNode(chip.dataset.facetLabel+': '+group.text),cross);
        const preserve=new Set(choices.filter(other=>other!==group).flatMap(other=>other.controls).filter(input=>input.checked).map(input=>input.value));
        const remove=new Set(group.controls.map(input=>input.value)), url=new URL(location.href);
        const remaining=url.searchParams.getAll(model.name).filter(value=>!remove.has(value)||preserve.has(value));
        url.searchParams.delete(model.name);remaining.forEach(value=>url.searchParams.append(model.name,value));
        url.searchParams.delete('page');url.hash='tf-results';chip.href=url.href;fragment.append(chip);
      });
      old[0].before(fragment);old.forEach(chip=>chip.remove());
    });
    current.dataset.activeCount=String(all('.tf-chip',current).length);
  }

  function showGroupCount(group, count) {
    q('[data-tf-count]', group.label).textContent = count === null ? '—' : String(count);
    group.input.disabled = !group.input.checked && !group.input.indeterminate && count === 0;
    group.label.classList.toggle('tf-disabled', group.input.disabled);
  }
  async function refreshGroupCounts() {
    countsController?.abort();
    countsController = new AbortController();
    const signal = countsController.signal, run = ++countsRun;
    const base = urlForForm(), pending = [];
    const activeColors = colorGroups.filter(group => group.model.facet.open && (!mobile.matches || dialog?.open));
    [...diameterGroups, ...activeColors].forEach(group => {
      const positive = group.originals.map(label => Number(q('[data-tf-count]', label).textContent)).filter(n => n > 0);
      if (positive.length < 2) { showGroupCount(group, positive[0] || 0); return; }
      const url = new URL(base);
      url.hash = ''; url.searchParams.set('section_id', form.dataset.section); url.searchParams.delete(group.name);
      group.controls.forEach(input => url.searchParams.append(group.name, input.value));
      url.searchParams.sort();
      const cached = countCache.get(url.href);
      if (cached && Date.now() - cached.time < 30000) { showGroupCount(group, cached.count); return; }
      showGroupCount(group, null);
      pending.push(async () => {
        try {
          const response = await fetch(url, {signal, credentials: 'same-origin'});
          if (!response.ok) throw new Error('diameter-count');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const raw = q('[data-ts-filter]', doc)?.dataset.count;
          if (raw === undefined || !/^\d+$/.test(raw)) throw new Error('diameter-count-markup');
          const count = Number(raw);
          if (run !== countsRun || signal.aborted) return;
          countCache.set(url.href, {count, time: Date.now()});
          showGroupCount(group, count);
        } catch (error) {
          if (error.name !== 'AbortError' && run === countsRun) showGroupCount(group, null);
        }
      });
    });
    const worker = async () => { while (pending.length && !signal.aborted) await pending.shift()(); };
    await Promise.all([worker(), worker()]);
  }
  function groupDiameterChips() {
    const current = q('[data-tf-current]');
    if (!current) return;
    const names = new Set(diameterGroups.map(group => group.name)), groups = new Map();
    all('[data-tf-remove][data-param]', current).forEach(chip => {
      const name = chip.dataset.param, number = diameter(chip.dataset.value);
      if (!names.has(name) || number === null) return;
      const key = name + ':' + number;
      if (groups.has(key)) { chip.remove(); return; }
      groups.set(key, chip);
      const text = chip.dataset.facetLabel + ': ' + diameterLabel(number);
      const cross = document.createElement('span'); cross.setAttribute('aria-hidden', 'true'); cross.textContent = '×';
      chip.replaceChildren(document.createTextNode(text), cross); chip.removeAttribute('aria-label');
      const url = new URL(location.href), remaining = url.searchParams.getAll(name).filter(value => diameter(value) !== number);
      url.searchParams.delete(name); remaining.forEach(value => url.searchParams.append(name, value));
      url.searchParams.delete('page'); url.hash = 'tf-results'; chip.href = url.href;
    });
    current.dataset.activeCount = String(all('.tf-chip', current).length);
  }

  function summary() {
    all('.tf-facet', form).forEach(facet => {
      const colorModel = colorModels.find(model => model.facet === facet);
      if (colorModel) { q('[data-tf-summary]', facet).textContent = colorSelections(colorModel).map(group => group.text).join(', '); return; }
      q('[data-tf-summary]', facet).textContent = all('input[type="checkbox"]:checked:not([data-tf-raw])', facet).map(i => i.closest('label').dataset.value).join(', ');
    });
  }
  function valid(report = false) {
    const min = q('#tf-min', form), max = q('#tf-max', form);
    if (max) max.setCustomValidity(min.value !== '' && max.value !== '' && +min.value > +max.value ? form.dataset.priceError : '');
    const ok = form.checkValidity();
    status(ok ? '' : form.dataset.priceError);
    if (!ok && report) {
      all('input:invalid', form).forEach(i => { const d = i.closest('details'); if (d) d.open = true; });
      form.reportValidity();
    }
    return ok;
  }
  function urlForForm() {
    const url = new URL(location.href);
    [...url.searchParams.keys()].forEach(k => { if (k.startsWith('filter.') || ['sort_by','page','section_id'].includes(k)) url.searchParams.delete(k); });
    const fields = new FormData(form);
    new Set(fields.keys()).forEach(name => url.searchParams.delete(name));
    fields.forEach((value, name) => { if (value !== '') url.searchParams.append(name, value); });
    url.hash = 'tf-results';
    return url;
  }
  function navigate(url) {
    cancelRequest();
    if (dialog?.open) close();
    q('[data-tf-apply]', form).textContent = form.dataset.loading;
    form.setAttribute('aria-busy', 'true');
    location.assign(url.href);
  }
  function submit() { if (valid(true)) navigate(urlForForm()); }
  async function preview() {
    clearTimeout(timer); controller?.abort(); countsController?.abort(); countsRun++;
    const run = ++generation;
    if (!valid()) return;
    const apply = q('[data-tf-apply]', form);
    apply.textContent = form.dataset.loading;
    const url = urlForForm(); url.hash = ''; url.searchParams.set('section_id', form.dataset.section);
    controller = new AbortController();
    try {
      const response = await fetch(url, {signal: controller.signal, credentials: 'same-origin'});
      if (!response.ok) throw new Error('filter-response');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fresh = q('[data-ts-filter]', doc);
      if (!fresh || run !== generation) { if (!fresh) throw new Error('filter-markup'); return; }
      apply.textContent = q('[data-tf-apply]', fresh).textContent;
      all('.tf-option input[name]', form).forEach(input => {
        const next = all('.tf-option input', fresh).find(n => n.name === input.name && n.value === input.value);
        const label = input.closest('.tf-option');
        const count = next ? q('[data-tf-count]', next.closest('.tf-option')).textContent : '0';
        q('[data-tf-count]', label).textContent = count;
        input.disabled = !input.checked && Number(count) === 0;
        label.classList.toggle('tf-disabled', input.disabled);
      });
      refreshGroupCounts();
      status('');
    } catch (error) {
      if (error.name === 'AbortError' || run !== generation) return;
      apply.textContent = form.dataset.apply;
      status(form.dataset.failure);
    }
  }
  function cancelRequest() { clearTimeout(timer); controller?.abort(); countsController?.abort(); countsRun++; generation++; }
  function close() {
    if (!dialog?.open) return;
    cancelRequest();
    dialog.close();
    home.append(form);
    saved.forEach(([input, value, disabled]) => { if (input.type === 'checkbox') input.checked = value; else input.value = value; input.disabled = disabled; });
    all('.tf-option', form).forEach(label => label.classList.toggle('tf-disabled', q('input',label).disabled));
    all('[data-tf-count]', form).forEach((node, i) => { node.textContent = form._counts[i]; });
    q('[data-tf-apply]', form).textContent = form._apply;
    document.documentElement.classList.remove('tf-modal-open');
    syncColors(); summary(); status(''); opener?.focus();
  }
  function open(button) {
    if (!mobile.matches) { form.scrollIntoView({block:'nearest'}); return; }
    cancelRequest();
    opener = button;
    saved = all('input',form).map(i => [i, i.type === 'checkbox' ? i.checked : i.value, i.disabled]);
    form._counts = all('[data-tf-count]', form).map(n=>n.textContent);
    form._apply = q('[data-tf-apply]', form).textContent;
    if (!dialog) {
      dialog = document.createElement('dialog'); dialog.className='tf-dialog'; dialog.setAttribute('aria-labelledby','tf-title');
      document.body.append(dialog);
      dialog.addEventListener('cancel', e=>{e.preventDefault();close();});
      dialog.addEventListener('click', e=>{if(e.target===dialog) close();});
    }
    dialog.append(form); dialog.showModal();
    document.documentElement.classList.add('tf-modal-open');
    q('[data-tf-close]',form).focus();
    refreshGroupCounts();
  }
  function init() {
    const next=q('[data-ts-filter]');
    if (!next || next===form) return;
    form=next; home=form.parentElement; form._baseApply=q('[data-tf-apply]',form).textContent;
    home.classList.add('tf-aside');
    document.documentElement.classList.add('tf-ready');
    groupDiameters();
    groupColors();
    groupDiameterChips();
    groupColorChips();
    summary();
    refreshGroupCounts();
    all('.tf-sizes',form).forEach(list => {
      const number = s => {const n=parseFloat(s.replace(',','.')); return Number.isFinite(n)?n:Infinity;};
      [...list.children].sort((a,b)=>number(a.dataset.value)-number(b.dataset.value)||a.dataset.value.localeCompare(b.dataset.value,undefined,{numeric:true})).forEach(n=>list.append(n));
    });
    const current=q('[data-tf-current]');
    all('a[href="#tf-filter"]').forEach(a=>{
      a.setAttribute('aria-controls','tf-filter');a.setAttribute('aria-haspopup','dialog');
      if (current && +current.dataset.activeCount) {const count=document.createElement('span');count.className='tf-badge';count.textContent=current.dataset.activeCount;a.append(count);}
    });
    form.addEventListener('submit',e=>{e.preventDefault();submit();});
    form.addEventListener('change',e=>{
      if (!e.target.matches('input')) return;
      summary(); cancelRequest();
      q('[data-tf-apply]',form).textContent=form.dataset.apply;
      if(mobile.matches) preview(); else if(e.target.type!=='number') submit();
    });
    form.addEventListener('input',e=>{
      if(e.target.type!=='number') return;
      cancelRequest();q('[data-tf-apply]',form).textContent=form.dataset.apply;
      if (mobile.matches) timer=setTimeout(preview,350);
    });
  }
  document.addEventListener('click',e=>{
    if (!form) return;
    const button=e.target.closest('a[href="#tf-filter"], [data-tf-close], [data-tf-reset], [data-tf-quick], [data-tf-clear], [data-tf-remove]');
    if(!button) return;
    if(e.metaKey||e.ctrlKey||e.shiftKey||e.altKey) return;
    e.preventDefault();
    if(button.matches('a[href="#tf-filter"]')) open(button);
    else if(button.matches('[data-tf-close]')) close();
    else if(button.matches('[data-tf-reset]')) {
      all('input[type="checkbox"], input[type="number"]',form).forEach(i=>{if(i.type==='checkbox'){i.checked=false;i.disabled=false;}else i.value='';});
      all('.tf-disabled',form).forEach(l=>l.classList.remove('tf-disabled'));
      syncColors(); summary(); if(mobile.matches) preview(); else submit();
    } else if(button.matches('[data-tf-quick]')) {
      const input=q('#tf-stock',form);input.checked=!input.checked;submit();
    } else {
      const url=new URL(button.href,location.href);
      const current=new URL(location.href);
      current.searchParams.forEach((value,key)=>{
        if (['sort_by','preview_theme_id','view','q','type'].includes(key) || key.startsWith('options[')) url.searchParams.set(key,value);
      });
      url.searchParams.delete('page');url.hash='tf-results';navigate(url);
    }
  });
  document.addEventListener('click',e=>{
    if(!form || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const item=e.target.closest('.bv_ul_inner > .li');
    const select=item?.closest('.bv_mainselect')?.previousElementSibling;
    if(!item || select?.id!=='sort_by' || item.matches('.bv_disabled, .nofocus, .bv_separator')) return;
    const items=all('.li',item.parentElement).filter(node=>!node.classList.contains('nofocus'));
    const option=select.options[items.indexOf(item)];
    if(!option || option.disabled) return;
    e.preventDefault();e.stopImmediatePropagation();
    select.value=option.value;
    q('input[name="sort_by"]',form).value=option.value;
    submit();
  },true);
  document.addEventListener('change',e=>{
    if(!form||e.target.id!=='sort_by')return;
    e.stopImmediatePropagation();q('input[name="sort_by"]',form).value=e.target.value;submit();
  },true);
  mobile.addEventListener('change',()=>{if(dialog?.open)close();});
  window.addEventListener('pageshow',event=>{if(event.persisted && form){form.removeAttribute('aria-busy');q('[data-tf-apply]',form).textContent=form._baseApply;}});
  document.addEventListener('shopify:section:load',init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
